module.exports = require("./ar-BH.js");